import { useState, useContext } from "react";
import { motion } from "framer-motion";
import Footer from "../../includes/footer-tab"; // Adjust path
import Preloader from "../Preloader"; // Adjust path
import BackButton from "../../includes/Back_btn"; // Adjust path
import { AuthContext } from "../../context/AuthContext"; // Adjust path
import styles from '../../assets/css/PrivacyPolicy.module.css'; // Import NEW CSS Module
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa"; // Icons
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ToastContainer } from 'react-toastify'; // Import Toast
import 'react-toastify/dist/ReactToastify.css';

function Privacypolicy() {
  const [preloader] = useState(false); // Kept false as per original
  const {
      WhatsappMessageSupport,
      TelegramLink = "https://t.me/aghoribabamatka", // Default Telegram link from context
      isAuthenticated // Needed for Footer logic potentially
    } = useContext(AuthContext);
  const navigate = useNavigate(); // Hook for navigation

  // Optional: Redirect if not authenticated, although this page might be public
  // useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate('/login');
  //   }
  // }, [isAuthenticated, navigate]);

  // Framer Motion variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100 } },
  };

  // Function to safely open links
  const openLink = (url) => {
      if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
      } else {
          // Optionally show a toast message if link is missing
          console.warn("Contact link is not available.");
          // Example using react-toastify (make sure it's imported)
          // toast.error("Contact link not available.", { theme: "dark" });
      }
  };

  return (
    <>
      <Preloader status={preloader} />
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />

      {/* Use the Aghori theme container */}
      <div className={styles.aghoriPolicyContainer}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          exit={{ opacity: 0 }}
        >
          {/* --- Header --- */}
          <motion.div className={styles.aghoriHeader} variants={itemVariants}>
            <BackButton className={styles.backButton} />
            <p className={styles.headerTitle}>Contact Us</p>
            {/* Optional: Placeholder for right-side icon/link if needed */}
            <div className={styles.headerPlaceholder}></div>
          </motion.div>

          {/* --- Content Area --- */}
          <motion.div className={styles.contentArea} variants={itemVariants}>
            {/* Informational Text */}
            <h1 className={styles.infoHeading}>
              {/* Keep original text or update as needed */}
              सब भाई ये फ़ोन पे से पेमेंट किया करो ऑटोमैटिक जुड़ जाता है अपलोड करने के बाद
            </h1>

            {/* Help Section */}
            <h2 className={styles.helpHeading}>
              Need Help (मदद की जरूरत है)
            </h2>

            {/* Button Container */}
            <div className={styles.buttonContainer}>
              {/* WhatsApp Button */}
              <button
                className={`${styles.contactButton} ${styles.whatsappButton}`}
                onClick={() => openLink(WhatsappMessageSupport)}
                disabled={!WhatsappMessageSupport} // Disable if link is missing
              >
                <FaWhatsapp /> हेल्प चाहिए WHATSAPP करो
              </button>

              {/* Telegram Button */}
              <button
                className={`${styles.contactButton} ${styles.telegramButton}`}
                onClick={() => openLink(TelegramLink)}
                disabled={!TelegramLink} // Disable if link is missing
              >
                <FaTelegramPlane /> हेल्प चाहिए TELEGRAM करो
              </button>

              {/* Call Button - Uncomment if needed */}
              {/* <button
                className={`${styles.contactButton} ${styles.callButton}`}
                onClick={() => openLink("tel:+919979068000")} // Replace number
              >
                 <FaPhoneAlt /> Call Now
              </button> */}
            </div>
          </motion.div>
        </motion.div>
      </div>
      {/* --- Footer --- */}
      {/* Pass appropriate prop if Footer needs to know the current page */}
      <Footer page="help" />
    </>
  );
}

export default Privacypolicy;
